import { clone } from "@/util/libUtil.js"

import defaultGestionForm from "./defaultGestionForm";
import defaultAtencionForm from "./defaultAtencionForm";

let defaultAtencionGestionForm = clone(defaultAtencionForm)
defaultAtencionGestionForm.gestion = clone(defaultGestionForm)

export default defaultAtencionGestionForm